<script>
  let {
    small = false
  } = $props();
</script>

<div class="column-divider" class:small></div>

<style>
  .column-divider {
    width: 1px;
    margin: 0;
    background-color: var(--color-default-foreground-800);
    align-self: stretch;
    overflow: hidden;
  }

  .column-divider::before {
    content: "\00a0"; /* Non-breaking space */
    display: inline-block;
    width: 1px;
  }

  .column-divider.small {
    align-self: center;
    height: 1em;
  }

  /* Prevent rendering duplicate column dividers next to each other */
  :global(.column-divider + .column-divider),
  :global(.column-divider:last-child),
  :global(.column-divider:first-child),
  :global(.column-divider:has(+ .column-divider)) {
    display: none;
  }
</style>